var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',_vm._b({ref:"select",attrs:{"reserve-keyword":"","filterable":"","remote":"","remote-method":_vm.remoteMethod},on:{"change":_vm.onChange}},'el-select',_vm.$attrs,false),_vm._l((_vm.options),function(item){return _c('el-option',{key:item.Id,attrs:{"value":item.Id,"label":item.Name}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }